import React, { useState } from 'react';
import Pagination from 'react-js-pagination';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    accountPagingAction,
    deleteAccountAction,
    filterListAccount
} from '@store/reducers/account';
import { resetSearch } from '@store/reducers/search';
import Table from 'react-bootstrap/Table';
import { Post, Get, DeleteSingle } from '../../utils/httpProvider';
import { URI_INTERNAL } from '../../utils/pathLocations';
import { ACCOUNT_POSITION_API, POSITION_API, ROLE_API } from '@app/utils/apiUrl';
import {
    createUrlWithParam,
    getInfomationAccountFromToken
} from '../../utils/helper';
import { objectShowNumber, messageToast, role } from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';

const Account = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const valueSearch = useSelector((state) => state.search.valueSearch);
    const listAccount = useSelector((state) => state.account.listAccount);

    const paramUrl = new URLSearchParams(location.search.substring(1));
    const [page, setPage] = useState(paramUrl.get('page') ? parseInt(paramUrl.get('page'), 10) : 1);
    const [pageSize, setPageSize] = useState(paramUrl.get('size') ? parseInt(paramUrl.get('size'), 10) : 20);
    const [search, setSearch] = useState(paramUrl.get('search') || '');
    const [positionFilter, setPositionFilter] = useState(paramUrl.get('positionId') || '');
    const initialRoleFilter = paramUrl.has('roleName') ? (paramUrl.get('roleName') || '') : 'APP_KPI_C9_ACCESS';
    const [roleFilter, setRoleFilter] = useState(initialRoleFilter);
    const [roleOptions, setRoleOptions] = useState([]);

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    let accountRoleAdmin = false;
    const inforAccount = getInfomationAccountFromToken();



    if (inforAccount && inforAccount.role) {
        const userRole = inforAccount.role.split(', ');
        accountRoleAdmin = userRole.includes(role.Admin);
    }

    const [positionsMap, setPositionsMap] = React.useState({});
    const [positionOptions, setPositionOptions] = React.useState([]);

    const getAccountId = (account) => account?.id || account?.Id;

    const getAccountPosition = (account) => {
        const accountId = getAccountId(account);
        const positionFromWebApi = positionsMap[accountId];

        return {
            positionId:
                positionFromWebApi?.positionId ||
                account?.accountAuthInfo?.positionId ||
                account?.AccountAuthInfo?.PositionId ||
                '',
            positionName:
                positionFromWebApi?.positionName ||
                account?.accountAuthInfo?.positionName ||
                account?.AccountAuthInfo?.PositionName ||
                'Chưa xác định'
        };
    };

    React.useEffect(() => {
        const fetchPositions = async () => {
            if (listAccount && listAccount.length > 0) {
                const ids = listAccount.map(acc => getAccountId(acc)).filter(Boolean);
                try {
                    const response = await Post(ACCOUNT_POSITION_API.GET_BY_ACCOUNT_IDS, null, ids);
                    const res = await response.json();
                    const posList = Array.isArray(res) ? res : (res?.data || res?.Data || []);
                    const map = {};
                    posList.forEach(pos => {
                        const accountId = pos.accountId || pos.AccountId;
                        map[accountId] = {
                            positionId: pos.positionId || pos.PositionId,
                            positionName: pos.positionName || pos.PositionName
                        };
                    });
                    setPositionsMap(map);
                } catch (error) {
                    console.error('Error fetching positions', error);
                }
            } else {
                setPositionsMap({});
            }
        };
        fetchPositions();
    }, [listAccount]);

    React.useEffect(() => {
        const fetchPositionOptions = async () => {
            try {
                const res = await Get(POSITION_API.GET_ALL_ACTIVE, null, null);
                const data = Array.isArray(res) ? res : (res?.data || res?.Data || []);
                setPositionOptions(
                    data.map((position) => ({
                        value: position.id || position.Id,
                        label: position.name || position.Name
                    }))
                );
            } catch (error) {
                console.error('Error fetching position options', error);
                setPositionOptions([]);
            }
        };

        fetchPositionOptions();
    }, []);



    React.useEffect(() => {
        const fetchRoleOptions = async () => {
            try {
                const res = await Get(ROLE_API.GET_PAGING, null, {
                    PageIndex: 1,
                    PageSize: 10000
                });
                const data = Array.isArray(res) ? res : (res?.data || res?.Data || []);
                setRoleOptions(
                    data.map((r) => ({
                        value: r.name || r.Name,
                        label: r.name || r.Name
                    }))
                );
            } catch (error) {
                console.error('Error fetching role options', error);
                setRoleOptions([]);
            }
        };

        fetchRoleOptions();
    }, []);

    const selectedPositionOption = positionOptions.find(
        (option) => String(option.value) === String(positionFilter)
    );
    const selectedRoleOption = roleOptions.find(
        (option) => String(option.value) === String(roleFilter)
    );

    const filteredListAccount = (listAccount || []).filter((account) => {
        // 1. Search Filter
        let matchSearch = true;
        if (search) {
            const key = search.toLowerCase().trim();
            const username = account.username?.toLowerCase() || '';
            const fullname = (
                account.fullname ||
                account.FullName ||
                (account.accountAuthInfo &&
                    `${account.accountAuthInfo.lastName || ''} ${account.accountAuthInfo.middleName || ''} ${account.accountAuthInfo.firstName || ''}`) ||
                ''
            ).toLowerCase();
            const email = (account.email || account.accountAuthInfo?.email || '').toLowerCase();
            matchSearch = username.includes(key) || fullname.includes(key) || email.includes(key);
        }

        // 2. Position Filter
        let matchPosition = true;
        if (positionFilter) {
            const { positionId, positionName } = getAccountPosition(account);
            if (positionId) {
                matchPosition = String(positionId) === String(positionFilter);
            } else {
                matchPosition =
                    selectedPositionOption &&
                    String(positionName).toLowerCase() ===
                    String(selectedPositionOption.label).toLowerCase();
            }
        }

        // 3. Role Filter
        let matchRole = true;
        if (roleFilter) {
            matchRole = account.roles?.some(
                (r) =>
                    String(r.name || r.Name).toLowerCase() === String(roleFilter).toLowerCase()
            ) || false;
        }

        return matchSearch && matchPosition && matchRole;
    });

    const totalItemsCount = filteredListAccount.length;
    const paginatedListAccount = filteredListAccount.slice(
        (page - 1) * pageSize,
        page * pageSize
    );


    const replaceHistory = (Page, Size, Search, RoleName, PositionId) => {
        const params = {
            page: Page,
            size: Size
        };
        if (Search) params.search = Search;
        if (RoleName) params.roleName = RoleName;
        if (PositionId) params.positionId = PositionId;

        history.replace(
            createUrlWithParam(URI_INTERNAL.ACCOUNT_PATH, params)
        );
    };

    // Fetch all accounts on mount for client-side search/filtering/pagination
    React.useEffect(() => {
        dispatch(accountPagingAction({ PageIndex: 1, PageSize: 10000 }));

        // Sync URL with initial states if not present
        if (!paramUrl.has('page') || !paramUrl.has('size') || !paramUrl.has('roleName')) {
            replaceHistory(page, pageSize, search, initialRoleFilter, positionFilter);
        }
    }, [dispatch]);

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setSearch(valueSearch);
            setPage(1);
            replaceHistory(1, pageSize, valueSearch, roleFilter, positionFilter);
        }
    }, [valueSearch]);

    // Reset search khi rời trang
    React.useEffect(() => {
        return () => {
            dispatch(resetSearch());
        };
    }, []);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, roleFilter, positionFilter);
    };

    const onChangeShowNumber = (e) => {
        const newSize = parseInt(e.target.value, 10) || 20;
        setPageSize(newSize);
        setPage(1);
        replaceHistory(1, newSize, search, roleFilter, positionFilter);
    };

    const onChangeSearch = (e) => {
        setSearch(e.target.value);
    };

    const onChangePositionFilter = (option) => {
        const newPosition = option?.value || '';
        setPositionFilter(newPosition);
        setPage(1);
        replaceHistory(1, pageSize, search, roleFilter, newPosition);
    };

    const onChangeRoleFilter = (option) => {
        const newRole = option?.value || '';
        setRoleFilter(newRole);
        setPage(1);
        replaceHistory(1, pageSize, search, newRole, positionFilter);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            try {
                const result = await dispatch(
                    deleteAccountAction(idWantDelete)
                );
                if (result.payload.errors) {
                    toast.error(result.payload.errors.content[0]);
                }
                if (result.payload === 200) {
                    await dispatch(filterListAccount(idWantDelete));
                    toast.success(messageToast.messageToastDeleteSuccess);

                    // Dual write Delete to WebApi
                    try {
                        const positionResponse = await DeleteSingle(
                            ACCOUNT_POSITION_API.DELETE_BY_ACCOUNT_ID,
                            idWantDelete,
                            null
                        );
                        if (!positionResponse?.ok) {
                            throw new Error('Xóa liên kết vị trí trên WebApi thất bại');
                        }
                    } catch (posError) {
                        console.error('Error dual-writing delete position', posError);
                        toast.warn('Đã xóa tài khoản nhưng chưa đồng bộ được vị trí sang WebApi.');
                    }

                    // history.goBack();

                    if (
                        listAccount != null &&
                        listAccount.length === 1 &&
                        page !== 1
                    ) {
                        history.push(
                            createUrlWithParam(URI_INTERNAL.DEVICE_PATH, {
                                page: page - 1,
                                size: pageSize,
                                search: search
                            })
                        );
                    }
                }
            } catch (error) {
                toast.error(messageToast.messageToastTryCatch);
            }
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title"> Danh sách tài khoản</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start flex-wrap">
                                <form
                                    className="form-inline"
                                    onSubmit={(e) => e.preventDefault()}
                                >
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="mr-2"
                                    >
                                        Hiển thị :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        type="text"
                                        className="form-control ml-2"
                                        style={{ width: '260px' }}
                                        placeholder="Tìm kiếm tài khoản (Nhấn Enter)"
                                        value={search}
                                        onChange={onChangeSearch}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                setPage(1);
                                                replaceHistory(1, pageSize, search, roleFilter, positionFilter);
                                            }
                                        }}
                                    />
                                    <div className="ml-2" style={{ width: '260px' }}>
                                        <Select
                                            isClearable
                                            placeholder="Lọc theo vị trí"
                                            options={positionOptions}
                                            value={selectedPositionOption || null}
                                            onChange={onChangePositionFilter}
                                        />
                                    </div>
                                    <div className="ml-2" style={{ width: '260px' }}>
                                        <Select
                                            isClearable
                                            placeholder="Lọc theo quyền"
                                            options={roleOptions}
                                            value={selectedRoleOption || null}
                                            onChange={onChangeRoleFilter}
                                        />
                                    </div>
                                </form>
                                <NavLink
                                    className="nav-link-reject nav-link"
                                    to={URI_INTERNAL.ACCOUNT_PATH_ADD}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                    >
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>
                            <div
                                id="example2_wrapper"
                                className="dataTables_wrapper dt-bootstrap4"
                                style={{ marginTop: '20px' }}
                            >
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr role="row">
                                                    <th className="sorting">
                                                        STT
                                                    </th>
                                                    <th className="sorting">
                                                        Tài khoản
                                                    </th>
                                                    <th className="sorting">
                                                        Quyền
                                                    </th>
                                                    <th className="sorting">
                                                        Vị trí
                                                    </th>
                                                    {/* <th className="sorting">
                                                        Họ tên
                                                    </th>
                                                    <th className="sorting">
                                                        Bút danh
                                                    </th>
                                                    <th className="sorting">
                                                        Email
                                                    </th> */}
                                                    <th className="sorting">
                                                        Trạng thái
                                                    </th>
                                                    <th className="sorting">
                                                        Chức năng
                                                    </th>
                                                </tr>
                                            </thead>
                                            {paginatedListAccount.length > 0 ? (
                                                <tbody>
                                                    {paginatedListAccount.map(
                                                        (item, index) => {
                                                            const accountId = getAccountId(item);
                                                            const accountPosition = getAccountPosition(item);
                                                            return (
                                                                <tr
                                                                    key={accountId || Number(index)}
                                                                    className="odd"
                                                                >
                                                                    <td className="dtr-control sorting_1">
                                                                        {index +
                                                                            1 +
                                                                            (page -
                                                                                1) *
                                                                            pageSize}
                                                                    </td>
                                                                    <td>
                                                                        <div className="fw-bold">{item.username}</div>
                                                                        {(() => {
                                                                            const authInfo = item.accountAuthInfo || item.AccountAuthInfo;
                                                                            let fullname = item.fullname || item.FullName || item.fullName || '';
                                                                            if (!fullname && authInfo) {
                                                                                fullname = `${authInfo.lastName || authInfo.LastName || ''} ${authInfo.middleName || authInfo.MiddleName || ''} ${authInfo.firstName || authInfo.FirstName || ''}`.replace(/\s+/g, ' ').trim();
                                                                            }
                                                                            return fullname ? (
                                                                                <div className="text-muted" style={{ fontSize: '0.85rem' }}>
                                                                                    {fullname}
                                                                                </div>
                                                                            ) : null;
                                                                        })()}
                                                                    </td>
                                                                    <td>
                                                                        {item.roles?.map(x => x.name).join(
                                                                            ', '
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {accountPosition.positionName ||
                                                                            item.accountAuthInfo?.positionName ||
                                                                            item.AccountAuthInfo?.PositionName ||
                                                                            'Chưa xác định'}
                                                                    </td>
                                                                    {/* <td>
                                                                    {
                                                                        item.fullname
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        item.pseudonym
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {item.email}
                                                                </td> */}
                                                                    <td>
                                                                        <div
                                                                            className={
                                                                                item.isActive
                                                                                    ? 'icheck-primary'
                                                                                    : 'icheck-danger'
                                                                            }
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                id={
                                                                                    accountId
                                                                                }
                                                                                name={
                                                                                    accountId
                                                                                }
                                                                                defaultChecked
                                                                            />
                                                                            <label
                                                                                htmlFor={
                                                                                    accountId
                                                                                }
                                                                            >
                                                                                {item.isActive
                                                                                    ? 'Đã kích hoạt'
                                                                                    : 'Chưa kích hoạt'}
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <ul className="nav">
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    to={createUrlWithParam(
                                                                                        URI_INTERNAL.ACCOUNT_PATH_EDIT,
                                                                                        {
                                                                                            id: accountId
                                                                                        }
                                                                                    )}
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Sửa"
                                                                                        className="nav-icon font-icon fas fa-pen"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                {accountRoleAdmin ? (
                                                                                    <NavLink
                                                                                        onClick={() =>
                                                                                            deleteAction(
                                                                                                accountId,
                                                                                                item.username
                                                                                            )
                                                                                        }
                                                                                        to
                                                                                        exact
                                                                                        className="nav-link"
                                                                                    >
                                                                                        <i
                                                                                            title="Xóa"
                                                                                            className="nav-icon font-icon far fa-trash-alt"
                                                                                        />
                                                                                    </NavLink>
                                                                                ) : (
                                                                                    <>
                                                                                    </>
                                                                                )}
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr className="txt-center">
                                                        <td colSpan="12">
                                                            Không có dữ liệu
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                            <tfoot>
                                                <tr role="row">
                                                    <th className="sorting">
                                                        STT
                                                    </th>
                                                    <th className="sorting">
                                                        Tài khoản
                                                    </th>
                                                    <th className="sorting">
                                                        Quyền
                                                    </th>
                                                    <th className="sorting">
                                                        Vị trí
                                                    </th>
                                                    {/* <th className="sorting">
                                                        Họ tên
                                                    </th>
                                                    <th className="sorting">
                                                        Email
                                                    </th> */}
                                                    <th className="sorting">
                                                        Trạng thái
                                                    </th>
                                                    <th className="sorting">
                                                        Chức năng
                                                    </th>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div
                                            className="dataTables_paginate paging_simple_numbers"
                                            id="example2_paginate"
                                        >
                                            <Pagination
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                innerClass="pagination pagination-sm no-margin pull-right"
                                                activePage={page}
                                                itemsCountPerPage={Number(
                                                    pageSize
                                                )}
                                                totalItemsCount={totalItemsCount}
                                                pageRangeDisplayed={5}
                                                onChange={(number) =>
                                                    changePage(number)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Account;
